import { faArrowRight } from '@fortawesome/sharp-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Image from 'next/image'
import Link from 'next/link'
import styles from './LeaderCard.module.scss'

function resolveImage(headshot) {
  if (!headshot) return { url: null, alt: '' }
  if (typeof headshot === 'string') return { url: headshot, alt: '' }
  const node = headshot.node ?? headshot
  return { url: node?.sourceUrl ?? null, alt: node?.altText ?? '' }
}

export default function LeaderCard({
  name,
  title,
  headshot,
  slug,
  href,
  ctaLabel,
  mobileCtaLabel,
  headingLevel = 3,
  className,
  sizes = '(max-width: 768px) 90vw, 350px',
  priority = false
}) {
  const { url: headshotUrl, alt } = resolveImage(headshot)
  const destination = href || (slug ? `/leadership/${String(slug).replace(/^\/+|\/+$/g, '')}` : null)
  const firstName = name?.trim().split(/\s+/)[0]
  const cta = ctaLabel || (firstName ? `Read ${firstName}'s Bio` : 'Read Bio')
  const mobileCta = mobileCtaLabel || (firstName ? `Meet ${firstName}` : 'Read Bio')
  // Clamped to 1-6: the level is interpolated into the tag name, so an out-of-range
  // prop would render an invalid, non-heading element such as <h0> or <h7>.
  const headingTag = Math.min(6, Math.max(1, Math.round(Number(headingLevel)) || 3))
  const Heading = `h${headingTag}`
  const Root = destination ? Link : 'div'
  const rootProps = destination ? { href: destination } : {}

  return (
    <Root className={[styles.leaderCard, className].filter(Boolean).join(' ')} {...rootProps}>
      {/* Leader Image */}
      <div className={styles.media}>
        {headshotUrl && <Image className={styles.headshot} src={headshotUrl} alt={alt || ''} fill sizes={sizes} priority={priority} />}
      </div>

      {/* Leader Text */}
      <div className={styles.footer}>
        {name && <Heading className={styles.name}>{name}</Heading>}
        {title && <p className={`eyebrow-text ${styles.title}`}>{title}</p>}
      </div>

      {/* Mobile only: redirect button to bio page */}
      <span className={styles.mobileCta}>
        {mobileCta} <FontAwesomeIcon icon={faArrowRight} />
      </span>

      {/* Desktop only: This is the panel that rises on hover */}
      <div className={styles.hoverPanel} aria-hidden="true">
        <span className={styles.hoverTexture} />

        <div className={styles.hoverText}>
          {name && <span className={styles.hoverName}>{name}</span>}
          {title && <span className={styles.hoverTitle}>{title}</span>}
        </div>

        <span className={styles.cta}>
          {cta} <FontAwesomeIcon icon={faArrowRight} />
        </span>
      </div>
    </Root>
  )
}
